import { JournalId, TripId } from 'types';

export const TRIPS = (journalId: JournalId) => `/api/v1/journals/${journalId}/trips`;
export const TRIP = (journalId: JournalId, tripId: TripId) =>
    `/api/v1/journals/${journalId}/trips/${tripId}`;
